import { render, staticRenderFns } from "./PublicListV2.vue?vue&type=template&id=e259b32e"
import script from "./PublicListV2.vue?vue&type=script&lang=ts"
export * from "./PublicListV2.vue?vue&type=script&lang=ts"
import style0 from "./PublicListV2.vue?vue&type=style&index=0&id=e259b32e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports